import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import $api, { API } from "../index";
import { IPlaylistByUrl } from "../../types/playlists";

export const playlistCards = createAsyncThunk(
  "playlistCard",

  async (publicUrl: string, { rejectWithValue }): Promise<IPlaylistByUrl> => {
    try {
      const data = await $api.get(`${API.playlistPath}/public/${publicUrl}`);
      return data.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);
